var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"ma-auto",attrs:{"id":"pie-chart-container"}},[_c('canvas',{staticClass:"pie-chart mx-auto",class:_vm.className,attrs:{"id":_vm.uniqueId,"width":"3","height":"3"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }